import { Component } from '@angular/core';
import { PrismicUtils } from '@segurosvoluntarios_vel/commons-services';
import { KeyResumenDePago } from 'src/app/pago/enums/KeyResumenDePago.enum';
import { ContenidoDeEstadoDePago } from 'src/app/pago/models/ContenidoDeEstadoDePago.model';
import { Pago } from 'src/app/pago/models/Pago.model';
import * as PrismicDOM from '@prismicio/helpers';
import { RowResumenDePago } from 'src/app/pago/models/RowResumenDePago.model';

@Component({
  template: '',
})
export abstract class BaseEstadoPagoComponent {
  contenido: ContenidoDeEstadoDePago;
  tenant: string;
  resumenesDePago: RowResumenDePago[];
  contenidoDescripcion: string;
  contenidoInformacionReintentos: string;
  contenidoTitulo: string;
  contenidoTextoEncuestaDeSatisfaccion: string;

  constructor(public prismicUtils: PrismicUtils) {}

  inicializar(pago: Pago, contenido: ContenidoDeEstadoDePago, tenant: string) {
    this.contenido = contenido;
    this.tenant = tenant;
    this.resumenesDePago = this.getResumenesDePago(pago);
    this.contenidoDescripcion = this.getContenidoDescripcion();
    this.contenidoInformacionReintentos = this.getContenidoInformacionReintentos();
    this.contenidoTitulo = this.getContenidoTitulo();
    this.contenidoTextoEncuestaDeSatisfaccion = this.getContenidoTextoEncuestaDeSatisfaccion();
  }

  getContenidoDescripcion(): string {
    return (
      this.contenido &&
      this.contenido.descripcion &&
      this.prismicUtils.convertTextAsHTML(
        this.contenido.descripcion,
        this.getSerializer
      )
    );
  }

  getContenidoInformacionReintentos(): string {
    return (
      this.contenido &&
      this.contenido.informacionReintentos &&
      this.prismicUtils.convertTextAsHTML(
        this.contenido.informacionReintentos,
        this.getSerializer
      )
    );
  }

  getContenidoTitulo(): string {
    return (
      this.contenido &&
      this.contenido.titulo &&
      this.prismicUtils.convertTextAsHTML(
        this.contenido.titulo,
        this.getSerializer
      )
    );
  }

  getContenidoTextoEncuestaDeSatisfaccion(): string {
    return (
      this.contenido &&
      this.contenido.textoEncuestaDeSatisfaccion &&
      this.prismicUtils.convertTextAsHTML(
        this.contenido.textoEncuestaDeSatisfaccion
      )
    );
  }

  private getResumenesDePago(pago: Pago): RowResumenDePago[] {
    const {
      estadoPago,
      banco,
      formaPago,
      cdResp,
      transaccion,
      total,
      cdAviso,
    } = pago;
    return [
      {
        key: KeyResumenDePago.ESTADO,
        value: estadoPago,
      },
      {
        key: KeyResumenDePago.BANCO,
        value: banco,
      },
      {
        key: KeyResumenDePago.VALOR,
        value: total,
      },
      {
        key: KeyResumenDePago.RECIBO,
        value: transaccion,
      },
      {
        key: KeyResumenDePago.CODIGO_RESPUESTA,
        value: cdResp,
      },
      {
        key: KeyResumenDePago.REFERENCIA_DE_PAGO,
        value: cdAviso,
      },
      {
        key: KeyResumenDePago.FORMA_PAGO,
        value: formaPago,
      },
    ].filter((resumenDePago: RowResumenDePago) => resumenDePago.value);
  }

  regresarAlComercio(urlRetorno: string) {
    window.location.href = urlRetorno;
  }

  getSerializer(type, element, content, children) {
    switch (type) {
      case PrismicDOM.Element.heading3:
        return `<h3 class="status__title my-4">` + children + '</h3>';
      case PrismicDOM.Element.paragraph:
        return (
          '<p class="contenedor-info-estado-pago__descripcion">' +
          children +
          '</p>'
        );
      default:
        return null;
    }
  }
}
